import type { CSSProperties } from 'react';

import { getBrand } from './brand';

interface BrandLogoProps {
  className?: string;
  style?: CSSProperties;
}

const BrandLogo = ({ className = 'Center Logo', style }: BrandLogoProps) => {
  const brand = getBrand();

  return <img src={brand.logo} alt={brand.logoAlt} className={className} style={style} />;
};

export default BrandLogo;
